import AiDocumentChunkTableItem from './AiDocumentChunkTableItem'

export default AiDocumentChunkTableItem
